// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SM2la","newExpiryDate":"styles_newExpiryDate__CzgWn","footer":"styles_footer__2tA7B"};